export const OTHER_STATE_OPTIONS = [
    {id: "active", name: "Active"},
    {id: "inactive", name: "Inactive"}
]

export enum OtherProfileSubtype {
    Employer = "employer",
    RetailCustomer = "retail_customer"
}

export const OTHER_SUBTYPE_OPTIONS = [
    {id: OtherProfileSubtype.Employer, name: "Employer"},
    {id: OtherProfileSubtype.RetailCustomer, name: "Retail Customer"}
]
